import { render, staticRenderFns } from "./MailPreviewModal.vue?vue&type=template&id=2d621711&scoped=true"
import script from "./MailPreviewModal.vue?vue&type=script&lang=js"
export * from "./MailPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./MailPreviewModal.vue?vue&type=style&index=0&id=2d621711&prod&lang=css"
import style1 from "./MailPreviewModal.vue?vue&type=style&index=1&id=2d621711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d621711",
  null
  
)

export default component.exports